import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faUnlock } from '@/fontawesome';

interface TradeTypeBadgesProps {
  type: 'LONG' | 'SHORT';
  boost: boolean;
  free: boolean;
  className?: string;
}

/**
 * Badge row for Swing and Long-Term trades: LONG/SHORT plus the optional BOOST and FREE markers.
 * Shared by the list cards and the shareable image card; no responsive variants.
 */
export default function TradeTypeBadges({ type, boost, free, className = '' }: TradeTypeBadgesProps) {
  return (
    <div className={`flex flex-wrap gap-1 mt-1 ${className}`}>
      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
        type === 'LONG'
          ? 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300'
          : 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300'
      }`}>
        {type}
      </span>
      {boost && (
        <span className="inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-400">
          <FontAwesomeIcon icon={faRocket} className="w-3 h-3 mr-1" />
          BOOST
        </span>
      )}
      {free && (
        <span className="inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400">
          <FontAwesomeIcon icon={faUnlock} className="w-3 h-3 mr-1" />
          FREE
        </span>
      )}
    </div>
  );
}
